// src/components/SEO.jsx
import React from 'react';
import { Helmet } from 'react-helmet';

export default function SEO() {
  const businessInfo = {
    name: "ARELY CONSTRUCTION & PAINTING LLC",
    description: "Professional painting and construction services in Roanoke, VA. Residential & commercial painting, renovations, landscaping, and tree services. Free estimates.",
    address: "4549 stonewall rd nw Roanoke VA 24017",
    phone: "(540) 525-1412",
    email: "am7254950@gmail.com",
    url: "https://www.arelypainting.com", // Replace with your actual domain
    imageUrl: "https://arely-media.s3.us-east-1.amazonaws.com/IMG_20250125_220734.jpg",
    priceRange: "$$",
    areaServed: [
      "Roanoke",
      "Salem",
      "Christiansburg",
      "Lynchburg",
      "Harrisonburg",
      "Troutville",
      "Blacksburg",
      "Floyd",
      "Pulaski",
      "Radford",
      "New River Valley"
    ],
    services: [
      "Residential Painting",
      "Commercial Painting",
      "Construction Services",
      "Landscaping",
      "Tree Trimming",
      "Exterior Brick Painting",
      "Interior Painting",
      "Home Renovation"
    ]
  };

  const keywords = [
    "painting Roanoke VA",
    "painters Salem VA",
    "construction services Roanoke",
    "residential painting Roanoke",
    "exterior brick painting Roanoke",
    "New River Valley painting",
    "trimming Roanoke",
    "best price painting Roanoke",
    "commercial painters Roanoke",
    "home renovation Roanoke",
    "professional painting services Virginia",
    "construction company Roanoke",
    "landscaping services VA",
    "tree trimming Roanoke"
  ].join(", ");

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{businessInfo.name} - Professional Painting Services in Roanoke VA</title>
      <meta name="description" content={businessInfo.description} />
      <meta name="keywords" content={keywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={businessInfo.url} />
      
      {/* Language */}
      <html lang="en" />
      
      {/* Viewport */}
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
      
      {/* Open Graph Tags */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={`${businessInfo.name} - Professional Painting Services`} />
      <meta property="og:description" content={businessInfo.description} />
      <meta property="og:image" content={businessInfo.imageUrl} />
      <meta property="og:url" content={businessInfo.url} />
      <meta property="og:site_name" content={businessInfo.name} />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${businessInfo.name} - Professional Painting Services`} />
      <meta name="twitter:description" content={businessInfo.description} />
      <meta name="twitter:image" content={businessInfo.imageUrl} />
      
      {/* Google Verification - Replace with your verification code */}
      <meta name="google-site-verification" content="YOUR_VERIFICATION_CODE" />
      
      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content={businessInfo.name} />
      <meta name="geo.region" content="US-VA" />
      <meta name="geo.placename" content="Roanoke" />
      <meta name="geo.position" content="37.2710;-79.9414" />
      <meta name="ICBM" content="37.2710, -79.9414" />

      {/* Schema.org Markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": businessInfo.name,
          "image": businessInfo.imageUrl,
          "@id": businessInfo.url,
          "url": businessInfo.url,
          "telephone": businessInfo.phone,
          "email": businessInfo.email,
          "priceRange": businessInfo.priceRange,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "4549 stonewall rd nw",
            "addressLocality": "Roanoke",
            "addressRegion": "VA",
            "postalCode": "24017",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 37.2710,
            "longitude": -79.9414
          },
          "areaServed": businessInfo.areaServed.map(area => ({
            "@type": "City",
            "name": area
          })),
          "serviceArea": {
            "@type": "GeoCircle",
            "geoMidpoint": {
              "@type": "GeoCoordinates",
              "latitude": 37.2710,
              "longitude": -79.9414
            },
            "geoRadius": "50000"
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Painting and Construction Services",
            "itemListElement": businessInfo.services.map((service, index) => ({
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": service
              }
            }))
          },
          "sameAs": [
            "https://www.instagram.com/arely.painting.llc"
          ],
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday"
            ],
            "opens": "07:00",
            "closes": "18:00"
          },
          "paymentAccepted": ["Cash", "Credit Card", "Check"],
          "currenciesAccepted": "USD"
        })}
      </script>
    </Helmet>
  );
}